import type { HugeiconsIconProps } from '@hugeicons/react'
import { HugeiconsIcon } from '@hugeicons/react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type HugeIcon = HugeiconsIconProps['icon']

interface EmptyStateProps {
  icon?: HugeIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-8 text-center',
        className,
      )}
    >
      {icon && (
        <HugeiconsIcon
          icon={icon}
          className="h-8 w-8 text-muted-foreground mb-3"
        />
      )}
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      {description && (
        <p className="text-xs text-muted-foreground mt-1">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
